import { SiteWideAlarmsScreen } from "@src/features/alarms/screens/SiteWideAlarmsTab.native";

export default function SitesScreen() {
  return <SiteWideAlarmsScreen />;
}
